import useSharedEntities from '../../../../modules/shared-entities/hooks/useSharedEntities';
import useGeneralSettingsStore from '../../../../stores/GeneralSettings/useGeneralSettingsStore';
import useGetProductTagGroups, { ProductTag } from '../../hooks/useGetProductTagGroups';
import useProductCardActions from '../../hooks/useProductCardActions';
import { ProductCardV2Props } from './types/productCardV2.types';

const TAG_TYPE_ORDER: Record<ProductTag['type'], number> = {
  suggested: 0,
  sellout: 1,
  colorClassification: 2,
};

const useProductCardV2View = ({
  item,
  catalogId,
  isSuggestedProduct,
  suggestedOrderActions,
  selloutMetrics,
}: ProductCardV2Props) => {
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);

  const { topTags, bottomTags } = useGetProductTagGroups({
    mediaFormat,
    customTags: item.customTags,
    isSuggestedProduct,
    selloutMetrics,
  });

  const tags = [...(topTags ?? []), ...(bottomTags ?? [])].sort(
    (first, second) => TAG_TYPE_ORDER[first.type] - TAG_TYPE_ORDER[second.type],
  );

  const { shouldDisableAllPrices, disableRetailPrice, disableWholesalePrice } = useSharedEntities(
    {},
  );

  const { isShopping, loading, onClickShopping, openDetails } = useProductCardActions({
    entityRelations: item.entityRelations,
    catalogId,
    suggestedOrderActions,
  });

  const onCardClick = () => openDetails();
  const onColorClick = (productColorId: string) => openDetails(productColorId);

  return {
    tags,
    price: {
      shouldDisableAllPrices,
      disableRetailPrice,
      disableWholesalePrice,
      hasPrices: item.prices.length > 0,
    },
    shopping: { isShopping, loading, onClickShopping },
    onCardClick,
    onColorClick,
  };
};

export default useProductCardV2View;
